export const GAME_ACTION_TYPES = {
  SET_IMAGES_STATE: " SET_IMAGES_STATE",
  SET_CURRENT_IMAGE: "SET_CURRENT_IMAGE",
  INCREMENT_COUNTER: "INCREMENT_COUNTER",
  RESET_COUNTER: "RESET_COUNTER",
  ADD_ITEM_TO_SHOWING_ARRAY: "ADD_ITEM_TO_SHOWING_ARRAY",
  REMOVE_ITEM_FROM_SHOWING_ARRAY: "REMOVE_ITEM_FROM_SHOWING_ARRAY",
  RESET_SHOWING_ARRAY: "RESET_SHOWING_ARRAY",
  RESET_MATCHED_IMAGES: "RESET_MATCHED_IMAGES",
  MATCHED_IMAGES: "MATCHED_IMAGES",
  LEVEL_STAR: "LEVEL_STAR",
  GAME_STATE: "GAME_STATE",
  ID_OF_SELECTED: "ID_OF_SELECTED",
};
